import React from 'react'
import injectSheet from 'react-jss'
import styles from './my-files-table.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import MyFilesEntry from './my-files-entry/my-files-entry.container'

const MyFilesTable = ({ classes, myFiles }) => (
  <Table>
    <thead>
      <tr>
        <HeadCell className={classes.left}>Thumb</HeadCell>
        <HeadCell className={classes.left}>Date</HeadCell>
        <HeadCell className={classes.titleCell}>Title</HeadCell>
        <HeadCell className={classes.left}>Student</HeadCell>
        <HeadCell className={classes.left}>Age group</HeadCell>
        <HeadCell className={classes.center}>Type</HeadCell>
        <HeadCell className={classes.center}>Judgement</HeadCell>
        <HeadCell className={classes.center}>Conclusion</HeadCell>
      </tr>
    </thead>
    <tbody>
      {myFiles.map(myFile => (
        <MyFilesEntry key={myFile.id} id={myFile.id} />
      ))}
    </tbody>
  </Table>
)

export default injectSheet(styles)(MyFilesTable)
